import './Story.scss';
import Stats from "../../components/stats/Stats";
import Pager from "../../components/pager/Pager";
import {useContext} from "react";
import StoryStats from "../../components/storyStats/StoryStats";
import switchIcon from "../../assets/icons/white/switch.svg";
import statsIcon from "../../assets/icons/green/stats.svg";
import logo from "../../assets/logo/parkl-logo-green.svg";
import calendar from "../../assets/icons/green/calendar.svg";
import {StoryContext} from "../../App";
import {useMediaQuery} from "react-responsive";
import Fade from "react-reveal/Fade";
import StoryHolder from "../../components/story/storyHolder";
import useShowContent from "../../components/useShowContent";

const video_l = 'https://parklcdn.azureedge.net/web/slide_videos/SC8-L.mp4';
const video_p = 'https://parklcdn.azureedge.net/web/slide_videos/SC8-P.mp4';

const Story8 = () => {
    const {state} = useContext(StoryContext);

    useShowContent(state.showContentDelay);

    const isLargeScreen = useMediaQuery({query: '(min-width: 900px)'});

    return (
        <>
            <div className={'video-content'}>
                <video src={isLargeScreen ? video_l : video_p} autoPlay={true} playsInline={true} muted={true}
                       className={'video'}/>
            </div>
            <div className={`container`}>

                <div className={`wrapper wrapper-story ${state.showStats ? `wrapper-stats` : ``}`}>
                    <Pager logo={logo}/>
                    <StoryHolder color={'white'}>

                    {state.showContent && (
                        <div className={'content-wrapper'}>
                            {!state.showStats && (
                                <Fade bottom={!state.statsShowed}>
                                        <div className={`content txt-white`}>
                                            {state.lang === 'hu' && (
                                                <>
                                                    <h1>Az első <span className={'txt-green'}>elektromos töltőállomás</span>
                                                    </h1>
                                                    Hisszük, hogy a jövő parkolásához szorosan hozzátartozik az elektromos autó
                                                    töltés, amire mihamarabb fel kell készülnünk.
                                                    <div className={'card-container'}>
                                                        <div className={`card bg-dark flex flex-align-center`}>
                                                            <img src={calendar} alt={'calendar-logo'}/>
                                                            <h2>Így, a Parkl ettől a pillanattól fogva már nem csak parkolási
                                                                szolgáltató.</h2>
                                                        </div>
                                                    </div>
                                                </>
                                            )}
                                            {state.lang !== 'hu' && (
                                                <>
                                                    <h1>Our first <span className={'txt-green'}>EV charger</span>
                                                    </h1>
                                                    We can’t imagine the future of parking without EV charging.
                                                    <div className={'card-container'}>
                                                        <div className={`card bg-dark flex flex-align-center`}>
                                                            <img src={calendar} alt={'calendar-logo'}/>
                                                            <h2>So, from now on, Parkl is not only a parking service provider.</h2>
                                                        </div>
                                                    </div>
                                                </>
                                            )}
                                        </div>
                                </Fade>
                            )}
                            {state.showStats && (
                                <StoryStats color={'white'}/>
                            )}
                        </div>
                    )}
                    </StoryHolder>

                    <Stats
                        switchIcon={switchIcon}
                        statsIcon={statsIcon}
                    />
                </div>
            </div>
        </>
    );
}

export default Story8;